import { useMatchingGuides } from "../../hooks/CmsHooks";
import "./style.scss";
import Icon from "../Icon";
import { guidesBaseUrl } from "../../config/urls";
import { Link } from "react-router-dom";

const GuideListing = ({
  category,
  tags,
  except = false,
  pathPrefix = guidesBaseUrl,
  beforeListing
}) => {
  const guides = useMatchingGuides(category, tags);
  const filteredGuides = guides.filter(
    guide => !except || guide._id !== except
  );

  if (filteredGuides.length > 0) {
    const documentItems = filteredGuides.map((guide, idx) => {
      return (
        <li key={idx}>
          <Link to={`${pathPrefix}/${guide.path}`}>
            <Icon name={"book-blank"} /> {guide.title}
          </Link>
        </li>
      );
    });
    return (
      <>
        {beforeListing}
        <ul className="guide-listing">{documentItems}</ul>
      </>
    );
  } else {
    return null; //<p>{t("no.matching.guides")}</p>;
  }
};

export default GuideListing;
